import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";
import { sortBy } from "lodash";
import SocialPlatformSection, { FacebookConnect, TwitterConnect, InstagramConnect, LinkedInConnect, GoogleMyBusinessConnect } from "./components";
import styles from "./styles.scss";
export default function SocialAccountList(_ref) {
  var config = _ref.config,
      socialAccounts = _ref.socialAccounts,
      handleRequestConnection = _ref.handleRequestConnection,
      onClickSettings = _ref.onClickSettings,
      organization = _ref.organization,
      rest = _objectWithoutProperties(_ref, ["config", "socialAccounts", "handleRequestConnection", "onClickSettings", "organization"]);

  var supportedPlatforms = sortBy([{
    type: "facebook",
    Render: handlePlatformRender,
    accounts: _toConsumableArray(socialAccounts).filter(function (_ref2) {
      var platform = _ref2.platform;
      return platform === "Facebook page";
    })
  }, {
    type: "twitter",
    displayName: "X (Twitter)",
    Render: handlePlatformRender,
    accounts: _toConsumableArray(socialAccounts).filter(function (_ref3) {
      var platform = _ref3.platform;
      return platform === "Twitter";
    })
  }, {
    type: "instagram",
    Render: handlePlatformRender,
    accounts: _toConsumableArray(socialAccounts).filter(function (_ref4) {
      var platform = _ref4.platform;
      return platform.includes("Instagram");
    })
  }, {
    type: "linkedin",
    displayName: "LinkedIn",
    Render: handlePlatformRender,
    accounts: _toConsumableArray(socialAccounts).filter(function (_ref5) {
      var platform = _ref5.platform;
      return platform.includes("LinkedIn");
    })
  }, {
    type: "googlemybusiness",
    displayName: "Google Business Profile",
    Render: handlePlatformRender,
    accounts: _toConsumableArray(socialAccounts).filter(function (_ref6) {
      var platform = _ref6.platform;
      return platform === "Google my business";
    })
  }], "type");
  var gmbFeature = true;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.platformWrap
  }, supportedPlatforms.map(function (_ref7) {
    var type = _ref7.type,
        Render = _ref7.Render,
        displayName = _ref7.displayName,
        accounts = _ref7.accounts;
    return type === "googlemybusiness" && !gmbFeature ? null : /*#__PURE__*/React.createElement(SocialPlatformSection, {
      key: type,
      platform: type,
      displayName: displayName
    }, /*#__PURE__*/React.createElement(Render, _extends({
      onRequestConnection: handleRequestConnection,
      platform: type,
      displayName: displayName,
      accounts: accounts,
      onClickSettings: onClickSettings
    }, rest)));
  }).filter(function (c) {
    return c;
  }));
}

function handlePlatformRender(props) {
  switch (props.platform) {
    case "facebook":
      return /*#__PURE__*/React.createElement(FacebookConnect, props);

    case "twitter":
      return /*#__PURE__*/React.createElement(TwitterConnect, props);

    case "instagram":
      return /*#__PURE__*/React.createElement(InstagramConnect, props);

    case "linkedin":
      return /*#__PURE__*/React.createElement(LinkedInConnect, props);

    case "googlemybusiness":
      return /*#__PURE__*/React.createElement(GoogleMyBusinessConnect, props);

    default:
      return null;
  }
}